import React, { Component } from "react";
import { Scope } from "informed";
import { TextInput, SelectInput, PublishAtPicker, ColorPicker, GradientInput, IconPicker } from "../../../shared/Forms";
import Switcher from "../../../ui/Switcher";
import PropTypes from "prop-types";

class PageInputs extends Component {
	constructor(props) {
		super(props);
		let type = "page";
		if (props.value) {
			type = props.value.pageId ? "page" : "url";
		}
		this.state = {
			type,
		};
	}

	changeType = (index, option) => {
		this.setState({ type: option.value });
	};

	render() {
		const { index, pages } = this.props;
		let data = [];
		if (pages && pages.length > 0) {
			data = pages.map(page => ({
				key: page.id,
				value: page.id,
				label: page.name,
			}));
		}
		const switcherOptions = [{ label: "Page", value: "page" }, { label: "URL", value: "url" }];
		return (
			<Scope scope={`pages[${index}]`}>
				<Switcher initialValue={this.state.type} options={switcherOptions} onSelect={this.changeType} />
				<div className="switcher-well">
					{this.state.type === "page" && (
						<div>
							{pages && pages.length > 0 && (
								<SelectInput field="pageId" id="pageId" values={data} placeholder="Page" />
							)}
						</div>
					)}
					{this.state.type === "url" && (
						<div>
							<TextInput field="url" id="url" placeholder="URL" />
						</div>
					)}
				</div>
				<PublishAtPicker field="publishAt" id="publishAt" placeholder="Date and Time to Publish Page" />
				<TextInput field="title" id="title" placeholder="Title" isRequired />
				<GradientInput field="backgroundGradient" id="backgroundGradient" placeholder="Background Gradient" />
				<ColorPicker field="backgroundColor" id="backgroundColor" placeholder="Background Color" />
				<IconPicker field="icon" id="icon" placeholder="Icon" />
			</Scope>
		);
	}
}

PageInputs.propTypes = {
	pages: PropTypes.array,
	index: PropTypes.number,
	value: PropTypes.object,
};

export default PageInputs;
